import { Conversacion } from "@/componentes/buzon/Conversacion"

/**
 * Buzón visto por el importador.
 *
 * Es el mismo componente y la misma API. El recorte a sus conversaciones lo hace
 * `aplicar_alcance_cliente` en el servidor, no esta pantalla: aquí no hay ninguna
 * comprobación de seguridad, y no debe haberla.
 */
export function BuzonPortal() {
  return (
    <Conversacion titulo="Buzón" subtitulo="Sus conversaciones con SETIECA sobre los despachos" />
  )
}
